export const GET_STORE_PRODUCTS_SUCCESS = 'GET_STORE_PRODUCTS_SUCCESS';
export const GET_STORE_PRODUCTS_START = 'GET_STORE_PRODUCTS_START';
export const GET_STORE_PRODUCTS_FAILED = 'GET_STORE_PRODUCTS_FAILED';

export const EDIT_STORE_PRODUCT_START = 'EDIT_STORE_PRODUCT_START';
export const EDIT_STORE_PRODUCT_SUCCESS = 'EDIT_STORE_PRODUCT_SUCCESS';
export const EDIT_STORE_PRODUCT_FAILED = 'EDIT_STORE_PRODUCT_FAILED';

export const DELETE_STORE_PRODUCT_START = 'DELETE_STORE_PRODUCT_START';
export const DELETE_STORE_PRODUCT_SUCCESS = 'DELETE_STORE_PRODUCT_SUCCESS';
export const DELETE_STORE_PRODUCT_FAILED = 'DELETE_STORE_PRODUCT_FAILED';

export const EDIT_STORE_PRODUCT_UPSELL_START = 'EDIT_STORE_PRODUCT_UPSELL_START';
export const EDIT_STORE_PRODUCT_UPSELL_SUCCESS = 'EDIT_STORE_PRODUCT_UPSELL_SUCCESS';
export const EDIT_STORE_PRODUCT_UPSELL_FAILED = 'EDIT_STORE_PRODUCT_UPSELL_FAILED';

export const REMOVE_STORE_PRODUCT_RELATED_LINKS_START = 'REMOVE_STORE_PRODUCT_RELATED_LINKS_START';
export const REMOVE_STORE_PRODUCT_RELATED_LINKS_SUCCESS = 'REMOVE_STORE_PRODUCT_RELATED_LINKS_SUCCESS';
export const REMOVE_STORE_PRODUCT_RELATED_LINKS_FAILED = 'REMOVE_STORE_PRODUCT_RELATED_LINKS_FAILED';

export const EDIT_STORE_PRODUCT_CROSS_SELL_START = 'EDIT_STORE_PRODUCT_CROSS_SELL_START';
export const EDIT_STORE_PRODUCT_CROSS_SELL_SUCCESS = 'EDIT_STORE_PRODUCT_CROSS_SELL_SUCCESS';
export const EDIT_STORE_PRODUCT_CROSS_SELL_FAILED = 'EDIT_STORE_PRODUCT_CROSS_SELL_FAILED';

export const GET_EDITABLE_STORE_PRODUCT_START = 'GET_EDITABLE_STORE_PRODUCT_START';
export const GET_EDITABLE_STORE_PRODUCT_SUCCESS = 'GET_EDITABLE_STORE_PRODUCT_SUCCESS';
export const GET_EDITABLE_STORE_PRODUCT_FAILED = 'GET_EDITABLE_STORE_PRODUCT_FAILED';

export const EDIT_USER_STORE_PRODUCTS = 'EDIT_USER_STORE_PRODUCTS';
export const EDIT_USER_STORE_PRODUCT_DESCRIPTION = 'EDIT_USER_STORE_PRODUCT_DESCRIPTION';

export const SAVE_STORE_PRODUCT_SUBSCRIPTION_ATTR_START = 'SAVE_STORE_PRODUCT_SUBSCRIPTION_ATTR_START';
export const SAVE_STORE_PRODUCT_SUBSCRIPTION_ATTR_SUCCESS = 'SAVE_STORE_PRODUCT_SUBSCRIPTION_ATTR_SUCCESS';
export const SAVE_STORE_PRODUCT_SUBSCRIPTION_ATTR_FAILED = 'SAVE_STORE_PRODUCT_SUBSCRIPTION_ATTR_FAILED';

export const SAVE_STORE_PRODUCT_MEDIA_GALLERY_START = 'SAVE_STORE_PRODUCT_MEDIA_GALLERY_START';
export const SAVE_STORE_PRODUCT_MEDIA_GALLERY_SUCCESS = 'SAVE_STORE_PRODUCT_MEDIA_GALLERY_SUCCESS';
export const SAVE_STORE_PRODUCT_MEDIA_GALLERY_FAILED = 'SAVE_STORE_PRODUCT_MEDIA_GALLERY_FAILED';

export const SAVE_ONE_TIME_PURCHASE_PRODUCT_ATTR_START = 'SAVE_ONE_TIME_PURCHASE_PRODUCT_ATTR_START';
export const SAVE_ONE_TIME_PURCHASE_PRODUCT_ATTR_SUCCESS = 'SAVE_ONE_TIME_PURCHASE_PRODUCT_ATTR_SUCCESS';
export const SAVE_ONE_TIME_PURCHASE_PRODUCT_ATTR_FAILED = 'SAVE_ONE_TIME_PURCHASE_PRODUCT_ATTR_FAILED';

export const GET_MASTER_CATALOG_PRODUCTS_START = 'GET_MASTER_CATALOG_PRODUCTS_START';
export const GET_MASTER_CATALOG_PRODUCTS_SUCCESS = 'GET_MASTER_CATALOG_PRODUCTS_SUCCESS';
export const GET_MASTER_CATALOG_PRODUCTS_FAILED = 'GET_MASTER_CATALOG_PRODUCTS_FAILED';

export const CATEGORY_PRODUCTS_SUCCESS = 'CATEGORY_PRODUCTS_SUCCESS';
export const GET_CATEGORY_PRODUCTS_START = 'GET_CATEGORY_PRODUCTS_START';
export const GET_CATEGORY_PRODUCTS_FAILED = 'GET_CATEGORY_PRODUCTS_FAILED';

export const UPDATE_CATEGORY_PRODUCTS = 'UPDATE_CATEGORY_PRODUCTS';
export const CHANGE_PRODUCT_CATEGORIES = 'CHANGE_PRODUCT_CATEGORIES';

export const SAVE_CATEGORY_PRODUCTS_START = 'SAVE_CATEGORY_PRODUCTS_START';
export const SAVE_CATEGORY_PRODUCTS_FAILED = 'SAVE_CATEGORY_PRODUCTS_FAILED';
export const SAVE_CATEGORY_PRODUCTS_SUCCESS = 'SAVE_CATEGORY_PRODUCTS_SUCCESS';

export const SAVE_PRODUCT_CATEGORIES_START = 'SAVE_PRODUCT_CATEGORIES_START';
export const SAVE_PRODUCT_CATEGORIES_SUCCESS = 'SAVE_PRODUCT_CATEGORIES_SUCCESS';
export const SAVE_PRODUCT_CATEGORIES_FAILED = 'SAVE_PRODUCT_CATEGORIES_FAILED';

export const CREATE_NEW_SUBSCRIPTION_OPTION = 'CREATE_NEW_SUBSCRIPTION_OPTION';
export const EDIT_NEW_SUBSCRIPTION_OPTION = 'EDIT_NEW_SUBSCRIPTION_OPTION';
export const SET_SUBSCRIPTION_OPTIONS = 'SET_SUBSCRIPTION_OPTIONS';
export const CHANGE_PRODUCT_SUBSCRIPTION_INSTALMENT_PRICE = 'CHANGE_PRODUCT_SUBSCRIPTION_INSTALMENT_PRICE';

export const ADD_SUBSCRIPTION_OPTION_START = 'ADD_SUBSCRIPTION_OPTION_START';
export const ADD_SUBSCRIPTION_OPTION_SUCCESS = 'ADD_SUBSCRIPTION_OPTION_SUCCESS';
export const ADD_SUBSCRIPTION_OPTION_FAILED = 'ADD_SUBSCRIPTION_OPTION_FAILED';

export const CANCEL_ADD_SUBSCRIPTION_OPTION = 'CANCEL_ADD_SUBSCRIPTION_OPTION';

export const EDIT_SUBSCRIPTION_OPTION_START = 'EDIT_SUBSCRIPTION_OPTION_START';
export const EDIT_SUBSCRIPTION_OPTION_SUCCESS = 'EDIT_SUBSCRIPTION_OPTION_SUCCESS';
export const EDIT_SUBSCRIPTION_OPTION_FAILED = 'EDIT_SUBSCRIPTION_OPTION_FAILED';

export const DELETE_SUBSCRIPTION_OPTION = 'DELETE_SUBSCRIPTION_OPTION';
export const DELETE_SUBSCRIPTION_OPTION_FAILED = 'DELETE_SUBSCRIPTION_OPTION_FAILED';

export const DELETE_ONE_TIME_SUBSCRIPTION_OPTION_START = 'DELETE_ONE_TIME_SUBSCRIPTION_OPTION_START';
export const DELETE_ONE_TIME_SUBSCRIPTION_OPTION_SUCCESS = 'DELETE_ONE_TIME_SUBSCRIPTION_OPTION_SUCCESS';
export const DELETE_ONE_TIME_SUBSCRIPTION_OPTION_FAILED = 'DELETE_ONE_TIME_SUBSCRIPTION_OPTION_FAILED';

export const SET_CUSTOM_OPTIONS = 'SET_CUSTOM_OPTIONS';
export const CANCEL_ADD_CUSTOM_OPTION = 'CANCEL_ADD_CUSTOM_OPTION';

export const ADD_CUSTOM_OPTION_START = 'ADD_CUSTOM_OPTION_START';
export const ADD_CUSTOM_OPTION_SUCCESS = 'ADD_CUSTOM_OPTION_SUCCESS';
export const ADD_CUSTOM_OPTION_FAILED = 'ADD_CUSTOM_OPTION_FAILED';

export const EDIT_CUSTOM_OPTION_START = 'EDIT_CUSTOM_OPTION_START';
export const EDIT_CUSTOM_OPTION_SUCCESS = 'EDIT_CUSTOM_OPTION_SUCCESS';
export const EDIT_CUSTOM_OPTION_FAILED = 'EDIT_CUSTOM_OPTION_FAILED';

export const DELETE_CUSTOM_OPTION_VALUE_SUCCESS = 'DELETE_CUSTOM_OPTION_VALUE_SUCCESS';
export const DELETE_CUSTOM_OPTION_START = 'DELETE_CUSTOM_OPTION_START';
export const DELETE_CUSTOM_OPTION_SUCCESS = 'DELETE_CUSTOM_OPTION_SUCCESS';

export const DELETE_CUSTOM_OPTION_FAILED = 'DELETE_CUSTOM_OPTION_FAILED';
export const DELETE_CUSTOM_OPTION_VALUE_START = 'DELETE_CUSTOM_OPTION_VALUE_START';
export const DELETE_CUSTOM_OPTION_VALUE_FAILED = 'DELETE_CUSTOM_OPTION_VALUE_FAILED';

export const GET_CUSTOM_OPTION_VALUE_BY_ID_FAILED = 'GET_CUSTOM_OPTION_VALUE_BY_ID_FAILED';
export const GET_CUSTOM_OPTION_VALUE_BY_ID_START = 'GET_CUSTOM_OPTION_VALUE_BY_ID_START';
export const GET_CUSTOM_OPTION_VALUE_BY_ID_SUCCESS = 'GET_CUSTOM_OPTION_VALUE_BY_ID_SUCCESS';

export const GET_CUSTOM_OPTIONS_PRICE_TYPES_START = 'GET_CUSTOM_OPTIONS_PRICE_TYPES_START';
export const GET_CUSTOM_OPTIONS_PRICE_TYPES_SUCCESS = 'GET_CUSTOM_OPTIONS_PRICE_TYPES_SUCCESS';
export const GET_CUSTOM_OPTIONS_PRICE_TYPES_FAILED = 'GET_CUSTOM_OPTIONS_PRICE_TYPES_FAILED';

export const SAVE_CUSTOM_OPTIONS_PRICE_TYPES_START = 'SAVE_CUSTOM_OPTIONS_PRICE_TYPES_START';
export const SAVE_CUSTOM_OPTIONS_PRICE_TYPES_SUCCESS = 'SAVE_CUSTOM_OPTIONS_PRICE_TYPES_SUCCESS';
export const SAVE_CUSTOM_OPTIONS_PRICE_TYPES_FAILED = 'SAVE_CUSTOM_OPTIONS_PRICE_TYPES_FAILED';

export const ADD_PRODUCT_TO_STORE_START = 'ADD_PRODUCT_TO_STORE_START';
export const ADD_PRODUCT_TO_STORE_SUCCESS = 'ADD_PRODUCT_TO_STORE_SUCCESS';
export const ADD_PRODUCT_TO_STORE_FAILED = 'ADD_PRODUCT_TO_STORE_FAILED';

export const MASS_ADD_PRODUCT_TO_STORE_START = 'MASS_ADD_PRODUCT_TO_STORE_START';
export const MASS_ADD_PRODUCT_TO_STORE_SUCCESS = 'MASS_ADD_PRODUCT_TO_STORE_SUCCESS';
export const MASS_ADD_PRODUCT_TO_STORE_WARNING = 'MASS_ADD_PRODUCT_TO_STORE_WARNING';
export const MASS_ADD_PRODUCT_TO_STORE_FAILED = 'MASS_ADD_PRODUCT_TO_STORE_FAILED';

export const GET_FBT_LINKS_START = 'GET_FBT_LINKS_START';
export const GET_FBT_LINKS_SUCCESS = 'GET_FBT_LINKS_SUCCESS';
export const GET_FBT_LINKS_FAILED = 'GET_FBT_LINKS_FAILED';

export const SAVE_FBT_LINKS_START = 'SAVE_FBT_LINKS_START';
export const SAVE_FBT_LINKS_SUCCESS = 'SAVE_FBT_LINKS_SUCCESS';
export const SAVE_FBT_LINKS_WARNING = 'SAVE_FBT_LINKS_WARNING';
export const SAVE_FBT_LINKS_FAILED = 'SAVE_FBT_LINKS_FAILED';

export const REMOVE_FBT_LINK_START = 'REMOVE_FBT_LINK_START';
export const REMOVE_FBT_LINK_SUCCESS = 'REMOVE_FBT_LINK_SUCCESS';
export const REMOVE_FBT_LINK_FAILED = 'REMOVE_FBT_LINK_FAILED';

export const ADD_UPSELL_LINKS = 'ADD_UPSELL_LINKS';

export const ADD_CROSS_SELL_LINKS = 'ADD_CROSS_SELL_LINKS';

export const SEND_DIRECT_FULFILLMENT_REQUEST_START = 'SEND_DIRECT_FULFILLMENT_REQUEST_START';
export const SEND_DIRECT_FULFILLMENT_REQUEST_SUCCESS = 'SEND_DIRECT_FULFILLMENT_REQUEST_SUCCESS';
export const SEND_DIRECT_FULFILLMENT_REQUEST_FAILED = 'SEND_DIRECT_FULFILLMENT_REQUEST_FAILED';

export const GET_STORE_PRODUCTS_EXPORT_START = 'GET_STORE_PRODUCTS_EXPORT_START';
export const GET_STORE_PRODUCTS_EXPORT_SUCCESS = 'GET_STORE_PRODUCTS_EXPORT_SUCCESS';
export const GET_STORE_PRODUCTS_EXPORT_FAILED = 'GET_STORE_PRODUCTS_EXPORT_FAILED';

export const ADD_TO_MASS_EDIT = 'ADD_TO_MASS_EDIT';

export const GET_STORE_TAX_CLASSES_START = 'GET_STORE_TAX_CLASSES_START';
export const GET_STORE_TAX_CLASSES_SUCCESS = 'GET_STORE_TAX_CLASSES_SUCCESS';
export const GET_STORE_TAX_CLASSES_FAILED = 'GET_STORE_TAX_CLASSES_FAILED';

export const GET_ALL_TASKS_FROM_QUEUE_START = 'GET_ALL_TASKS_FROM_QUEUE_START';
export const GET_ALL_TASKS_FROM_QUEUE_SUCCESS = 'GET_ALL_TASKS_FROM_QUEUE_SUCCESS';
export const GET_ALL_TASKS_FROM_QUEUE_FAILED = 'GET_ALL_TASKS_FROM_QUEUE_FAILED';

export const ADD_TASKS_TO_QUEUE_START = 'ADD_TASKS_TO_QUEUE_START';
export const ADD_TASKS_TO_QUEUE_SUCCESS = 'ADD_TASKS_TO_QUEUE_SUCCESS';
export const ADD_TASKS_TO_QUEUE_FAILED = 'ADD_TASKS_TO_QUEUE_FAILED';

export const REMOVE_TASK_FROM_QUEUE_START = 'REMOVE_TASK_FROM_QUEUE_START';
export const REMOVE_TASK_FROM_QUEUE_SUCCESS = 'REMOVE_TASK_FROM_QUEUE_SUCCESS';
export const REMOVE_TASK_FROM_QUEUE_FAILED = 'REMOVE_TASK_FROM_QUEUE_FAILED';

export const RECEIVE_QUEUED_TASK_UPDATE = 'RECEIVE_QUEUED_TASK_UPDATE';

export const ADD_PATIENT_CERTIFICATION_START = 'ADD_PATIENT_CERTIFICATION_START';
export const ADD_PATIENT_CERTIFICATION_SUCCESS = 'ADD_PATIENT_CERTIFICATION_SUCCESS';
export const ADD_PATIENT_CERTIFICATION_FAILED = 'ADD_PATIENT_CERTIFICATION_FAILED';

export const EDIT_PATIENT_CERTIFICATION_START = 'EDIT_PATIENT_CERTIFICATION_START';
export const EDIT_PATIENT_CERTIFICATION_SUCCESS = 'EDIT_PATIENT_CERTIFICATION_SUCCESS';
export const EDIT_PATIENT_CERTIFICATION_FAILED = 'EDIT_PATIENT_CERTIFICATION_FAILED';

export const SET_PATIENT_CERTIFICATION_START = 'SET_PATIENT_CERTIFICATION_START';
export const SET_PATIENT_CERTIFICATION_SUCCESS = 'SET_PATIENT_CERTIFICATION_SUCCESS';
export const SET_PATIENT_CERTIFICATION_FAILED = 'SET_PATIENT_CERTIFICATION_FAILED';

export const DELETE_PATIENT_CERTIFICATION_START = 'DELETE_PATIENT_CERTIFICATION_START';
export const DELETE_PATIENT_CERTIFICATION_SUCCESS = 'DELETE_PATIENT_CERTIFICATION_SUCCESS';
export const DELETE_PATIENT_CERTIFICATION_FAILED = 'DELETE_PATIENT_CERTIFICATION_FAILED';

export const getStoreProductsSuccess = (products) => ({
  type: GET_STORE_PRODUCTS_SUCCESS,
  products
});

export const getStoreProductsStart = () => ({
  type: GET_STORE_PRODUCTS_START
});

export const getStoreProductsFailed = (error) => ({
  type: GET_STORE_PRODUCTS_FAILED,
  error
});

export const getCategoryProductsSuccess = (data, categoryId) => ({
  type: CATEGORY_PRODUCTS_SUCCESS,
  data,
  categoryId
});

export const getCategoryProductsStart = () => ({
  type: GET_CATEGORY_PRODUCTS_START
});

export const getCategoryProductsFailed = () => ({
  type: GET_CATEGORY_PRODUCTS_FAILED
});

export const changeCategoryProducts = (actionName, categoryId, product) => ({
  type: UPDATE_CATEGORY_PRODUCTS,
  actionName,
  categoryId,
  product
});

export const changeProductCategories = (actionName, categoryId, product) => ({
  type: CHANGE_PRODUCT_CATEGORIES,
  actionName,
  categoryId,
  product
});

export const saveStoreProductsByCategoryStart = () => ({
  type: SAVE_CATEGORY_PRODUCTS_START
});

export const saveStoreProductsByCategorySuccess = () => ({
  type: SAVE_CATEGORY_PRODUCTS_SUCCESS
});

export const saveStoreProductsByCategoryFailed = () => ({
  type: SAVE_CATEGORY_PRODUCTS_FAILED
});

export const saveStoreProductCategoriesStart = () => ({
  type: SAVE_PRODUCT_CATEGORIES_START
});

export const saveStoreProductCategoriesSuccess = () => ({
  type: SAVE_PRODUCT_CATEGORIES_SUCCESS
});

export const saveStoreProductCategoriesFailed = () => ({
  type: SAVE_PRODUCT_CATEGORIES_FAILED
});

export const editStoreProductStart = () => ({
  type: EDIT_STORE_PRODUCT_START,
});
export const editStoreProductSuccess = (product, sku, showMessage) => ({
  type: EDIT_STORE_PRODUCT_SUCCESS,
  product,
  sku,
  showMessage
});
export const editStoreProductFailed = () => ({
  type: EDIT_STORE_PRODUCT_FAILED,
});

export const deleteStoreProductStart = () => ({
  type: DELETE_STORE_PRODUCT_START,
});
export const deleteStoreProductSuccess = (sku, data) => ({
  type: DELETE_STORE_PRODUCT_SUCCESS,
  sku,
  data
});
export const deleteStoreProductFailed = () => ({
  type: DELETE_STORE_PRODUCT_FAILED,
});

export const editStoreProductUpSellStart = () => ({
  type: EDIT_STORE_PRODUCT_UPSELL_START,
});
export const editStoreProductUpSellSuccess = (product) => ({
  type: EDIT_STORE_PRODUCT_UPSELL_SUCCESS,
  product
});
export const editStoreProductUpSellFailed = () => ({
  type: EDIT_STORE_PRODUCT_UPSELL_FAILED,
});

export const removeStoreProductRelatedLinksStart = () => ({
  type: REMOVE_STORE_PRODUCT_RELATED_LINKS_START,
});
export const removeStoreProductRelatedLinksSuccess = (product) => ({
  type: REMOVE_STORE_PRODUCT_RELATED_LINKS_SUCCESS,
  product
});
export const removeStoreProductRelatedLinksFailed = () => ({
  type: REMOVE_STORE_PRODUCT_RELATED_LINKS_FAILED,
});

export const editStoreProductCrossSellStart = () => ({
  type: EDIT_STORE_PRODUCT_CROSS_SELL_START,
});
export const editStoreProductCrossSellSuccess = (product) => ({
  type: EDIT_STORE_PRODUCT_CROSS_SELL_SUCCESS,
  product
});
export const editStoreProductCrossSellFailed = () => ({
  type: EDIT_STORE_PRODUCT_CROSS_SELL_FAILED,
});

export const saveOneTimePurchaseProductAttrStart = () => ({
  type: SAVE_ONE_TIME_PURCHASE_PRODUCT_ATTR_START
});

export const saveOneTimePurchaseProductAttrSuccess = (product, sku) => ({
  type: SAVE_ONE_TIME_PURCHASE_PRODUCT_ATTR_SUCCESS,
  product,
  sku
});

export const saveOneTimePurchaseProductAttrFailed = () => ({
  type: SAVE_ONE_TIME_PURCHASE_PRODUCT_ATTR_FAILED
});

export const getEditableStoreProductStart = () => ({
  type: GET_EDITABLE_STORE_PRODUCT_START
});

export const getEditableStoreProductSuccess = (product) => ({
  type: GET_EDITABLE_STORE_PRODUCT_SUCCESS,
  product
});

export const getEditableStoreProductFailed = () => ({
  type: GET_EDITABLE_STORE_PRODUCT_FAILED
});

export const editUserStoreProduct = (customProductValue) => ({
  type: EDIT_USER_STORE_PRODUCTS,
  customProductValue
});

export const editUserStoreProductDescription = (value, key) => ({
  type: EDIT_USER_STORE_PRODUCT_DESCRIPTION,
  value,
  key
});

export const getMasterCatalogProductsStart = () => ({
  type: GET_MASTER_CATALOG_PRODUCTS_START
});

export const getMasterCatalogProductsSuccess = (data, brand, brandType) => ({
  type: GET_MASTER_CATALOG_PRODUCTS_SUCCESS,
  data,
  brand,
  brandType
});

export const getMasterCatalogProductsFailed = () => ({
  type: GET_MASTER_CATALOG_PRODUCTS_FAILED
});

export const createSubscriptionOption = (name, value, productId, productPrice, optionId) => ({
  type: CREATE_NEW_SUBSCRIPTION_OPTION,
  name,
  value,
  productId,
  productPrice,
  optionId
});

export const editSubscriptionOption = (value, productId, productPrice, optionId) => ({
  type: EDIT_NEW_SUBSCRIPTION_OPTION,
  value,
  productId,
  productPrice,
  optionId
});

export const getProductSubscriptionOptionsSuccess = (options) => ({
  type: SET_SUBSCRIPTION_OPTIONS,
  options
});

export const getProductCustomOptionsSuccess = (options) => ({
  type: SET_CUSTOM_OPTIONS,
  options
});

export const addSubscriptionOptionStart = () => ({
  type: ADD_SUBSCRIPTION_OPTION_START
});

export const addProductSubscriptionOptionSuccess = (data) => ({
  type: ADD_SUBSCRIPTION_OPTION_SUCCESS,
  data
});

export const addSubscriptionOptionFailed = () => ({
  type: ADD_SUBSCRIPTION_OPTION_FAILED
});

export const cancelAddSubscriptionOption = () => ({
  type: CANCEL_ADD_SUBSCRIPTION_OPTION
});

export const cancelAddCustomnOption = () => ({
  type: CANCEL_ADD_CUSTOM_OPTION
});

export const changeProductSubscriptionInstalmentPrice = (price) => ({
  type: CHANGE_PRODUCT_SUBSCRIPTION_INSTALMENT_PRICE,
  price
});

export const editProductSubscriptionOptionStart = () => ({
  type: EDIT_SUBSCRIPTION_OPTION_START
});

export const editProductSubscriptionOptionSuccess = (options) => ({
  type: EDIT_SUBSCRIPTION_OPTION_SUCCESS,
  options
});

export const editProductSubscriptionOptionFailed = () => ({
  type: EDIT_SUBSCRIPTION_OPTION_FAILED
});


export const saveStoreProductSubscriptionAttrStart = () => ({
  type: SAVE_STORE_PRODUCT_SUBSCRIPTION_ATTR_START
});

export const saveStoreProductSubscriptionAttrSuccess = (product, sku, attributeCode) => ({
  type: SAVE_STORE_PRODUCT_SUBSCRIPTION_ATTR_SUCCESS,
  product,
  sku,
  attributeCode
});

export const saveStoreProductSubscriptionAttrFailed = (e) => ({
  type: SAVE_STORE_PRODUCT_SUBSCRIPTION_ATTR_FAILED,
  e
});

export const saveStoreProductMediaGalleryStart = () => ({
  type: SAVE_STORE_PRODUCT_MEDIA_GALLERY_START
});

export const saveStoreProductMediaGallerySuccess = (product) => ({
  type: SAVE_STORE_PRODUCT_MEDIA_GALLERY_SUCCESS,
  product
});

export const saveStoreProductMediaGalleryFailed = (e) => ({
  type: SAVE_STORE_PRODUCT_MEDIA_GALLERY_FAILED,
  e
});


export const deleteProductSubscriptionOptionSuccess = (id) => ({
  type: DELETE_SUBSCRIPTION_OPTION,
  id
});

export const deleteProductSubscriptionOptionFailed = () => ({
  type: DELETE_SUBSCRIPTION_OPTION_FAILED
});

export const deleteOneTimeSubscriptionOptionStart = () => ({
  type: DELETE_ONE_TIME_SUBSCRIPTION_OPTION_START
});

export const deleteOneTimeSubscriptionOptionSuccess = (id) => ({
  type: DELETE_ONE_TIME_SUBSCRIPTION_OPTION_SUCCESS,
  id
});

export const deleteOneTimeSubscriptionOptionFailed = () => ({
  type: DELETE_ONE_TIME_SUBSCRIPTION_OPTION_FAILED
});

export const addCustomOptionStart = () => ({
  type: ADD_CUSTOM_OPTION_START
});

export const addCustomOptionSuccess = (data) => ({
  type: ADD_CUSTOM_OPTION_SUCCESS,
  data
});

export const addCustomOptionFailed = () => ({
  type: ADD_CUSTOM_OPTION_FAILED
});

export const deleteCustomOptionStart = () => ({
  type: DELETE_CUSTOM_OPTION_START
});

export const deleteCustomOptionSuccess = (id) => ({
  type: DELETE_CUSTOM_OPTION_SUCCESS,
  id
});

export const deleteCustomOptionFailed = () => ({
  type: DELETE_CUSTOM_OPTION_FAILED
});

export const deleteCustomOptionValueStart = () => ({
  type: DELETE_CUSTOM_OPTION_VALUE_START
});

export const deleteCustomOptionValueFailed = () => ({
  type: DELETE_CUSTOM_OPTION_VALUE_FAILED
});

export const editCustomOptionStart = () => ({
  type: EDIT_CUSTOM_OPTION_START
});

export const editCustomOptionSuccess = (option) => ({
  type: EDIT_CUSTOM_OPTION_SUCCESS,
  option
});

export const editCustomOptionFailed = () => ({
  type: EDIT_CUSTOM_OPTION_FAILED
});

export const deleteCustomOptionValueSuccess = (options) => ({
  type: DELETE_CUSTOM_OPTION_VALUE_SUCCESS,
  options
});

export const getCustomOptionByIdStart = () => ({
  type: GET_CUSTOM_OPTION_VALUE_BY_ID_START
});

export const getCustomOptionByIdFailed = () => ({
  type: GET_CUSTOM_OPTION_VALUE_BY_ID_FAILED
});

export const getCustomOptionByIdSuccess = (customOption) => ({
  type: GET_CUSTOM_OPTION_VALUE_BY_ID_SUCCESS,
  customOption
});

export const getCustomOptionsPriceTypesStart = () => ({
  type: GET_CUSTOM_OPTIONS_PRICE_TYPES_START,
});

export const getCustomOptionsPriceTypesSuccess = (data) => ({
  type: GET_CUSTOM_OPTIONS_PRICE_TYPES_SUCCESS,
  data
});

export const getCustomOptionsPriceTypesFailed = (error) => ({
  type: GET_CUSTOM_OPTIONS_PRICE_TYPES_FAILED,
  error
});

export const saveCustomOptionsPriceTypesStart = () => ({
  type: SAVE_CUSTOM_OPTIONS_PRICE_TYPES_START,
});

export const saveCustomOptionsPriceTypesSuccess = (data) => ({
  type: SAVE_CUSTOM_OPTIONS_PRICE_TYPES_SUCCESS,
  data
});

export const saveCustomOptionsPriceTypesFailed = (error) => ({
  type: SAVE_CUSTOM_OPTIONS_PRICE_TYPES_FAILED,
  error
});

export const addProductToStoreStart = () => ({
  type: ADD_PRODUCT_TO_STORE_START
});

export const addProductToStoreSuccess = (product) => ({
  type: ADD_PRODUCT_TO_STORE_SUCCESS,
  product
});

export const addProductToStoreFailed = (error, product) => ({
  type: ADD_PRODUCT_TO_STORE_FAILED,
  error,
  product
});

export const massAddProductToStoreStart = () => ({
  type: MASS_ADD_PRODUCT_TO_STORE_START
});

export const massAddProductToStoreSuccess = (products) => ({
  type: MASS_ADD_PRODUCT_TO_STORE_SUCCESS,
  products
});

export const massAddProductToStoreWarning = (products) => ({
  type: MASS_ADD_PRODUCT_TO_STORE_WARNING,
  products
});

export const massAddProductToStoreFailed = (products) => ({
  type: MASS_ADD_PRODUCT_TO_STORE_FAILED,
  products
});

export const getFBTLinksStart = () => ({
  type: GET_FBT_LINKS_START
});

export const getFBTLinksSuccess = (data) => ({
  type: GET_FBT_LINKS_SUCCESS,
  data
});

export const getFBTLinksFailed = (error) => ({
  type: GET_FBT_LINKS_FAILED,
  error
});

export const saveFBTLinksStart = () => ({
  type: SAVE_FBT_LINKS_START
});

export const saveFBTLinksSuccess = (data, entity) => ({
  type: SAVE_FBT_LINKS_SUCCESS,
  data,
  entity
});

export const saveFBTLinksWarning = (data) => ({
  type: SAVE_FBT_LINKS_WARNING,
  data
});

export const saveFBTLinksFailed = (error) => ({
  type: SAVE_FBT_LINKS_FAILED,
  error
});

export const removeFBTLinkStart = () => ({
  type: REMOVE_FBT_LINK_START
});

export const removeFBTLinkSuccess = (linkedProductSku) => ({
  type: REMOVE_FBT_LINK_SUCCESS,
  linkedProductSku
});

export const removeFBTLinkFailed = (error) => ({
  type: REMOVE_FBT_LINK_FAILED,
  error
});

export const addUpSellLinks = (data) => ({
  type: ADD_UPSELL_LINKS,
  data
});

export const addCrossSellLinks = (data) => ({
  type: ADD_CROSS_SELL_LINKS,
  data
});

export const sendDirectFulfillmentRequestStart = () => ({
  type: SEND_DIRECT_FULFILLMENT_REQUEST_START
});

export const sendDirectFulfillmentRequestSuccess = (data) => ({
  type: SEND_DIRECT_FULFILLMENT_REQUEST_SUCCESS,
  data
});

export const sendDirectFulfillmentRequestFailed = (error) => ({
  type: SEND_DIRECT_FULFILLMENT_REQUEST_FAILED,
  error
});

export const getStoreProductsExportStart = () => ({
  type: GET_STORE_PRODUCTS_EXPORT_START
});

export const getStoreProductsExportSuccess = (data) => ({
  type: GET_STORE_PRODUCTS_EXPORT_SUCCESS,
  data
});

export const getStoreProductsExportFailed = () => ({
  type: GET_STORE_PRODUCTS_EXPORT_FAILED
});

export const addToMassEdit = (products, productsType = '') => ({
  type: ADD_TO_MASS_EDIT,
  products,
  productsType
});

export const getStoreTaxClassesStart = () => ({
  type: GET_STORE_TAX_CLASSES_START
});

export const getStoreTaxClassesSuccess = (data) => ({
  type: GET_STORE_TAX_CLASSES_SUCCESS,
  data
});

export const getStoreTaxClassesFailed = () => ({
  type: GET_STORE_TAX_CLASSES_FAILED
});

export const getAllTasksFromQueueStart = () => ({
  type: GET_ALL_TASKS_FROM_QUEUE_START
});

export const getAllTasksFromQueueSuccess = (data, storeViewCode) => ({
  type: GET_ALL_TASKS_FROM_QUEUE_SUCCESS,
  data,
  storeViewCode
});

export const getAllTasksFromQueueFailed = (error) => ({
  type: GET_ALL_TASKS_FROM_QUEUE_FAILED,
  error
});

export const addTasksToQueueStart = () => ({
  type: ADD_TASKS_TO_QUEUE_START
});

export const addTasksToQueueSuccess = (data) => ({
  type: ADD_TASKS_TO_QUEUE_SUCCESS,
  data
});

export const addTasksToQueueFailed = (error) => ({
  type: ADD_TASKS_TO_QUEUE_FAILED,
  error
});

export const removeTaskFromQueueStart = () => ({
  type: REMOVE_TASK_FROM_QUEUE_START
});

export const removeTaskFromQueueSuccess = (data) => ({
  type: REMOVE_TASK_FROM_QUEUE_SUCCESS,
  data
});

export const removeTaskFromQueueFailed = (error) => ({
  type: REMOVE_TASK_FROM_QUEUE_FAILED,
  error
});

export const receiveQueuedTaskUpdate = (data) => ({
  type: RECEIVE_QUEUED_TASK_UPDATE,
  data
});

export const addPatientCertificationStart = () => ({
  type: ADD_PATIENT_CERTIFICATION_START
});

export const addPatientCertificationSuccess = (data) => ({
  type: ADD_PATIENT_CERTIFICATION_SUCCESS,
  data
});

export const addPatientCertificationFailed = (error) => ({
  type: ADD_PATIENT_CERTIFICATION_FAILED,
  error
});

export const editPatientCertificationsStart = () => ({
  type: EDIT_PATIENT_CERTIFICATION_START
});

export const editPatientCertificationsSuccess = (data) => ({
  type: EDIT_PATIENT_CERTIFICATION_SUCCESS,
  data
});

export const editPatientCertificationsFailed = (error) => ({
  type: EDIT_PATIENT_CERTIFICATION_FAILED,
  error
});

export const setPatientCertificationStart = () => ({
  type: SET_PATIENT_CERTIFICATION_START
});

export const setPatientCertificationSuccess = (data) => ({
  type: SET_PATIENT_CERTIFICATION_SUCCESS,
  data
});

export const setPatientCertificationFailed = (error) => ({
  type: SET_PATIENT_CERTIFICATION_FAILED,
  error
});

export const deletePatientCertificationStart = () => ({
  type: DELETE_PATIENT_CERTIFICATION_START
});

export const deletePatientCertificationSuccess = (data) => ({
  type: DELETE_PATIENT_CERTIFICATION_SUCCESS,
  data
});

export const deletePatientCertificationsFailed = (error) => ({
  type: DELETE_PATIENT_CERTIFICATION_FAILED,
  error
});
